'use client';

import { createContext, useContext } from 'react';
import { Locale } from '@altus-ui/common';
import {
  type I18nHelper,
  getI18n,
  MAP_LOCALE_TO_LANG,
  SUPPORTED_LANGUGES
} from '@altus-ui/i18n';

export interface IGlobalClientContext {
  i18nHelper: I18nHelper;
  locale: Locale;
  language: SUPPORTED_LANGUGES;
}

const GlobalClientContext = createContext<IGlobalClientContext>({} as any);

export function useGlobalClientContext() {
  return useContext(GlobalClientContext);
}

export function GlobalClientContextProvider({
  children,
  locale
}: {
  children: any;
  locale: Locale;
}) {
  const currLocal = locale || Locale.ko_KR;
  const i18nHelper = getI18n(currLocal);

  const global: IGlobalClientContext = {
    i18nHelper,
    locale: currLocal,
    language: MAP_LOCALE_TO_LANG[currLocal]
  };
  return (
    <GlobalClientContext.Provider value={global}>
      {children}
    </GlobalClientContext.Provider>
  );
}
